import React from "react";
import { Link } from "react-router-dom";
import { FaGlobeAmericas, FaUsers, FaMapSigns } from "react-icons/fa";
import "animate.css";
import af7 from "../assets/af11.jpg";
import missionVideo from "../assets/rhin.mp4";

const AboutPage = () => {
  const handleMouseEnter = () => {
    // Optional: Add hover effect like changing style or logging
  };
  
  const handleMouseLeave = () => {
    // Optional: Reset style or other behavior
  };
  return (
    <div style={styles.container}>
      {/* Who We Are Section */}
      <section style={styles.aboutSection}>
        <div style={styles.sectionContent}>
          <h2 className="animate__animated animate__fadeIn" style={styles.sectionTitle}>Who We Are</h2>
          <div className="animate__animated animate__fadeIn animate__delay-1s" style={styles.row}>
            <div style={styles.textBlock}>
              <p style={styles.sectionText}>
                At Wango Trails Safaris, we curate transformative travel experiences that connect people with the wonders of nature.
                From exhilarating wildlife safaris in the heart of Africa to remote cultural encounters in the farthest corners of the world,
                we offer unparalleled adventures for every traveler. Our team is passionate about providing personalized journeys that
                inspire and educate, leaving you with memories that last a lifetime.
              </p>
            </div>
            <img src={af7} alt="About Us" style={styles.sectionMedia} />
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section style={styles.missionSection}>
        <div style={styles.sectionContent}>
          <h2 className="animate__animated animate__fadeIn" style={styles.sectionTitle}>Our Mission</h2>
          <div className="animate__animated animate__fadeIn animate__delay-1s" style={styles.row}>
            <div style={styles.videoCard}>
              <video style={styles.missionVideo} autoPlay muted loop playsInline>
                <source src={missionVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div style={styles.textBlock}>
              <p style={styles.sectionText}>
                Our mission is to empower travelers to explore the world sustainably, ensuring every journey is enriching and purposeful.
                We believe in the power of travel to create connections, foster understanding, and promote environmental stewardship.
                Whether it’s witnessing the majesty of wildlife, exploring new cultures, or discovering hidden gems, our goal is to offer
                meaningful experiences that contribute to the conservation of nature and the well-being of local communities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section style={styles.servicesSection}>
        <div style={styles.sectionContent}>
          <h2 className="animate__animated animate__fadeIn" style={styles.sectionTitle}>What We Offer</h2>
          <div className="animate__animated animate__fadeIn animate__delay-1s" style={styles.services}>
            {[
              {
                icon: <FaGlobeAmericas size={50} style={styles.icon} />,
                title: "Tailored Travel Experiences",
                desc: "Personalized tours to fit your dream vacation. Whether you're seeking a relaxing getaway or an adrenaline-pumping adventure, we tailor each experience to your preferences.",
              },
              {
                icon: <FaUsers size={50} style={styles.icon} />,
                title: "Group Adventures",
                desc: "Explore with like-minded travelers in guided group tours. Share memorable experiences with a community of explorers from around the world.",
              },
              {
                icon: <FaMapSigns size={50} style={styles.icon} />,
                title: "Expert Guides",
                desc: "Our expert guides ensure a safe and informative experience, sharing insights into local wildlife, culture, and history.",
              },
              {
                icon: <FaGlobeAmericas size={50} style={styles.icon} />,
                title: "Sustainable Travel",
                desc: "We are committed to responsible tourism. Our tours are designed to minimize environmental impact while maximizing cultural and ecological benefits.",
              },
              {
                icon: <FaUsers size={50} style={styles.icon} />,
                title: "Cultural Immersion",
                desc: "Experience authentic cultural exchanges. Our tours provide opportunities to connect with local communities and learn about their traditions, art, and lifestyles.",
              },
              {
                icon: <FaMapSigns size={50} style={styles.icon} />,
                title: "Luxury and Comfort",
                desc: "We combine adventure with comfort, ensuring that your journey is as relaxing as it is exciting, with access to premium accommodations and amenities.",
              },
            ].map((service, index) => (
              <div key={index} style={styles.serviceCard}>
                {service.icon}
                <h3 style={styles.serviceTitle}>{service.title}</h3>
                <p style={styles.serviceDescription}>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Floating CTA */}
      <div style={styles.floatingCTA}>
  <a
    href="https://mail.google.com/mail/?view=cm&fs=1&to=wangotrailsafaris@gmail.comm&su=Booking%20Inquiry&body=Hi,%0D%0A%0D%0AI%20want%20to%20book%20assist%20me"
    style={styles.ctaButton}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    target="_blank"
    rel="noopener noreferrer"
  >
    Book Your Tour
  </a>
</div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "'Roboto', sans-serif",
  },
  sectionTitle: {
    fontSize: "2.5rem",
    marginBottom: "30px",
    textTransform: "uppercase",
    fontWeight: "bold",
    textAlign: "center",
  },
  aboutSection: {
    padding: "80px 20px",
    backgroundColor: "#f4f4f4",
  },
  missionSection: {
    padding: "80px 20px",
    backgroundColor: "#fff",
  },
  sectionContent: {
    maxWidth: "1200px",
    margin: "0 auto",
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "40px",
    flexDirection: "row",
  },
  sectionText: {
    fontSize: "1rem",
    color: "#333",
    lineHeight: "1.6",
  },
  textBlock: {
    flex: 1,
    minWidth: "300px",
  },
  sectionMedia: {
    flex: 1,
    width: "100%",
    maxWidth: "500px",
    borderRadius: "10px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    objectFit: "cover",
  },
  videoCard: {
    flex: 1,
    minWidth: "300px",
    maxWidth: "500px",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#000",
  },
  missionVideo: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  servicesSection: {
    backgroundColor: "#fff",
    padding: "80px 20px",
    textAlign: "center",
  },
  services: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap",
    marginTop: "30px",
  },
  serviceCard: {
    backgroundColor: "#fff",
    padding: "40px",
    width: "280px",
    borderRadius: "15px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    transition: "transform 0.3s ease",
    marginBottom: "30px",
    cursor: "pointer",
  },
  icon: {
    color: "#ff6347",
    marginBottom: "15px",
  },
  serviceTitle: {
    fontSize: "1.3rem",
    marginTop: "10px",
    fontWeight: "bold",
  },
  serviceDescription: {
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.6",
  },
  floatingCTA: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
  },
  ctaButton: {
    padding: "15px 40px",
    backgroundColor: "#ff6347",
    color: "#fff",
    fontSize: "1.2rem",
    borderRadius: "30px",
    textDecoration: "none",
    fontWeight: "bold",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease",
  },
};

export default AboutPage;
